import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApps = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 4,
			width: 6.5,
			height: 6.5,
			rx: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 13.5,
			y: 4,
			width: 6.5,
			height: 6.5,
			rx: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 13.5,
			width: 6.5,
			height: 6.5,
			rx: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 13.5,
			y: 13.5,
			width: 6.5,
			height: 6.5,
			rx: 1.5
		})
	]
});
const ForwardRef = forwardRef(SvgApps);
export default ForwardRef;
